module.exports = __webpack_public_path__ + "static/media/29.45a21cd4.jpg";